<template>
	<section v-if="items.length" class="promotions align-center background-light">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<div class="image">
						<h3>
							<nuxt-link :to="block.link">
								{{ block.header }}
							</nuxt-link>
						</h3>
						<picture>
							<source :srcset="block.imageWebp" type="image/webp" />
							<source :srcset="block.image" />
							<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
						</picture>
					</div>
					<div class="content">
						<div v-parse-links v-html="block.content" />
						<nuxt-link :to="block.link" class="button no-fill" target="_self">
							{{ $t('readMore') }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions .columns {
	display: flex;
}

.promotion {
	background-color: var(--primary-background-color);
	margin: 0 auto 20px;
	box-shadow: 0 0 10px rgb(0 0 0 / 10%);
	position: relative;
	overflow: hidden;
	width: 100%;

	.content {
		background: #fff;
		position: relative;
		width: 100%;
		z-index: 3;
		padding: 40px;
	}

	.image {
		display: block;
		overflow: hidden;
		position: relative;

		h3 {
			position: absolute;
			z-index: 3;
			top: 50px;
			left: 40px;
			color: #fff;
			text-decoration: none;

			a {
				color: #fff;
				text-decoration: none;
			}
		}

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			background: rgb(0 0 0 / 10%);
			z-index: 2;
		}

		img {
			transition: all 0.3s ease-in-out;
			background: #000;
			z-index: 1;
			position: relative;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}

@media (max-width: 580px) {
	.promotion {
		.content {
			text-align: left;
		}
	}
}
</style>
